import {PassengerData} from '../components/passengerData';
import { useRef, useState, useEffect } from "react";
import { Modal } from "../components/modal";
import { getAutofills } from "../utils/api/getAutofills.js";
import balearia_logo from "../images/logos/balearia.png";
import acciona_logo from "../images/logos/acciona.jpg";
import armas_logo from "../images/logos/acciona.jpg";
import frs_logo from "../images/logos/frs.jpg";
import flecha from "../images/flecha-card.svg";
import reloj from "../images/billreloj.svg";
import tarjetas from "../images/tarjetas-bill.svg";
import timon from "../images/timon-azul.svg";

import { booking } from "../utils/api/booking";

function logo(navy) {
  switch (navy) {
    case "Balearia":
      return balearia_logo;
    case "Armas":
      return armas_logo;
    case "Acciona":
      return acciona_logo;
    case "FRS":
      return frs_logo;
    default:
      return "";
  }
}




export function Data({ user, searchData, changeSection, selectedSailing, selectedSailingBack }) {


  const childRefs = useRef([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [idMilitar, setIdMilitar] = useState();
  const [idFamily, setIdFamily] = useState();
  const [email, setEmail] = useState();
  const [mobile, setMobile] = useState();
  const [autofill, setAutofill] = useState();

  const openModal = () => {
    setIsModalOpen(true); // Abrir modal
  };

  const isMilitary = () => {
    const militarys = ["ET1", "ET2", "ET3", "FN1", "FN2", "FN3", "GCS", "POL"];
    return (militarys.indexOf(searchData.advantage) > -1);
  }

  const closeModal = () => {
    setIsModalOpen(false); // Cerrar modal
  };



  console.log("Selected sailing: ", selectedSailing);


  function total_price() {
    if(searchData.returnDate != null) {
      var go_price = Number(selectedSailing.tariff.discounted_price) || Number(selectedSailing.tariff.price)
      var back_price = Number(selectedSailingBack.tariff.discounted_price) || Number(selectedSailingBack.tariff.price)
      var total = go_price + back_price;

      return total
    }
  
    return Number(selectedSailing.tariff.discounted_price) || Number(selectedSailing.tariff.price)
  }

  function total_not_discounted_price() {
    if(searchData.returnDate != null) {
      var go_price =  Number(selectedSailing.tariff.price)
      var back_price = Number(selectedSailingBack.tariff.price)
      var total = go_price + back_price;

      return total
    }else{
      var total = Number(selectedSailing.tariff.price)
    }

    return total
  }

  function total_discount(){
    return (total_not_discounted_price() - total_price())
  }


  const loadAutofills = async () => {
    if(!user) return;
    const loadedAutofillData = await getAutofills(user);
    setAutofill(loadedAutofillData)
  }

  useEffect(() => {
    window.scrollTo(0, 0)
    loadAutofills();
  }, [])

  const handleClick = () => {
    let result = [];
    for (let i = 0; i < searchData.numAdults+searchData.numKids+searchData.numBabies; i++) {
      if (childRefs.current[i]) {
        result.push( childRefs.current[i].validateForm())
      }
    }

    console.log("Result: ", result)
    // Check if all elements are true
    let valid = result.every((element) => element !== false);
  
    const email = document.getElementsByName("email")[0].value;
    if(email == ""|| email == null){
      valid = false;
    }
    const mobile = document.getElementsByName("mobile")[0].value;
    if(mobile == ""|| mobile == null){
      valid = false;
    }
    if(isMilitary()&&(idMilitar == ""|| idMilitar == null)){
        valid = false;
    }
  
    if (valid) {
      openModal();
      let passengers = []
  
      for (let index = 0; index < result.length; index++) {
        passengers.push({
          kind: result[index].kind,
          name: result[index].name,
          document_type: result[index].documentType,
          surnames: result[index].surnames,
          dni: result[index].documentNumber,
          birthDate: result[index].birthDateDay+"-"+result[index].birthDateMonth+"-"+result[index].birthDateYear,
          expDate: result[index].expDateDay+"-"+result[index].expDateMonth+"-"+result[index].expDateYear,
          nationality: result[index].nationality,
          passengerType: result[index].passengerType,
          sex: result[index].sex
        });
        
      }

      

      let bookingData = {
        email: email,
        phone: mobile,
        outward_day: searchData.departureDate,
        backward_day: searchData.returnDate,
        origen: searchData.origen,
        destiny: searchData.destiny,
        outward_time: selectedSailing.sailingData.outward_time,
        backward_time: selectedSailing.sailingData.backward_time,
        one_way: searchData.returnDate == null,
        acco_code: selectedSailing.acco_code,
        tariff_code: selectedSailing.tariff.tariff_code,
        acco_code_back: selectedSailing.acco_code,
        tariff_code_back: selectedSailing.tariff.tariff_code,
        accommodation: selectedSailing.name,
        accommodation_back: selectedSailing.name,
        amount: selectedSailing.tariff.price,
        company: selectedSailing.sailingData.company,
        advantage: searchData.advantage,
        residence: searchData.residence,
        id_familly: idFamily,
        id_militar: idMilitar,
        passengers: passengers,
        discount_amount: total_discount(),
      }

      booking(selectedSailing.sailingData.company, bookingData, user).then((response) => {
        closeModal();
        console.log("Booking response: ", response);
        if(response.redirect != null){
          window.location.href = "https://portalferries.es" + response.redirect;
        }else if(response.error != null){
          alert(response.error);
        }

        
      }).catch((error) => { alert("Error al realizar la reserva:",error) });
    } else {
      alert("Por favor, rellene todos los campos");
    }
  };

  function showAdults() {
    let adults=[];
    for (let i = 0; i < searchData.numAdults; i++) {
      adults.push( <PassengerData autofill={autofill} kind={"Adulto"} ref={(el) => (childRefs.current[i] = el)} index={i}/>)
    }
    return adults;
  }

  function showChildrens() {
    let childrens=[];
    for (let i = searchData.numAdults; i < searchData.numAdults+searchData.numKids; i++) {
      childrens.push( <PassengerData autofill={autofill} kind={"Niño"}  ref={(el) => (childRefs.current[i] = el)} index={i}/>)
    }
    return childrens;
  }
  function showBabies() {
    let babies=[];
    for (let i = searchData.numAdults+searchData.numKids; i < searchData.numAdults+searchData.numKids+searchData.numBabies; i++) {
      babies.push( <PassengerData autofill={autofill} kind={"Bebe"}  ref={(el) => (childRefs.current[i] = el)} index={i}/>)
    }
    return babies;
  }
  
  const formatter = new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
  

  });

  return (<> 
  
  <div className="t-resBu">
    <div className="o-stepMax">
      <div className="container">
        <div className="o-stepMax__loop">
          <div className="step ">
            <div>
              <span>1</span>
            </div>
            <div>
              <span>Buscar ferry</span>
            </div>
          </div>
          <div className="arrow"></div>
          <div className="step">
            <div>
              <span>2</span>
            </div>
            <div>
              <span>Selecciona tu viaje</span>
            </div>
          </div>
          <div className="arrow active"></div>
          <div className="step active">
            <div>
              <span>3</span>
            </div>
            <div>
              <span>Datos personales</span>
            </div>
          </div>
          <div className="arrow "></div>
          <div className="step ">
            <div>
              <span>4</span>
            </div>
            <div>
              <span>Finalizar compra</span>
            </div>
          </div>
        </div>
      </div>
    </div>



  </div>
  <div className="content">
    <div className="total container_data content-section bg-b-BluePolar">
    
      <div className="container_passengers">
        {showAdults()}
        {showChildrens()}
        {showBabies()}
        <div className="m-layPay">
          <div className="m-bxFrmPay">
            <div className="bx">
              {isMilitary() && (
                <> 
                  <div className="m-frmGroup is-normal">
                    <label>TIM</label>
                    <input className="data-input" placeholder="TIM" name="email" onChange={setIdMilitar}/>
                  </div>
                </>)
              }
              <div className="m-frmGroup is-normal">
                <label>Email</label>
                <input className="data-input" placeholder="Email" name="email" />
                
                <div className="a-msg">Si no recibe su email, revise su carpeta de SPAM</div>
              </div>
              <div className="m-frmGroup is-normal">
                <label>Telefono</label>
                <input className="data-input" placeholder="Telefono" name="mobile" />
              </div>
            </div>  
          </div>
        </div>
      </div>

      <div className="container container_payment">
        <div className="m-bxBillPay">
          <div className="m-bxBillPay__bill">
            <div className="o-cardTicket o-cardTicket--min">
              <div className="a-tagTray"><span>Trayecto de ida</span></div>
              <div className="bx">
                <div className="o-cardTicket__fecha">
                  {searchData.departure_date}
                </div>
                                                              
                <div className="o-cardTicket__logo">
                  <div className="bx">
                    <img src={logo(selectedSailing.sailingData.company)}  />
                  </div>
                </div>
                <div className="o-cardTicket__trayecto">
                  <div className="bx">
                    <div className="row">
                      <div className="cardHead">
                        <div className="tit ht-small-bold text-center">Travesía</div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="orDe tit">
                        <div>{searchData.origen}</div>
                        <div> 
                          <img src={flecha} alt="flecha-card" />
                        </div>
                        <div>{searchData.destiny}</div>
                      </div>
                      <div className="duracion">
                        <div className="bx">
                        <img src={reloj} />
                          <span>{selectedSailing.sailingData.outward_time}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="o-cardTicket__resultado">
                  <span className="price">{formatter.format(selectedSailing.tariff.discounted_price) || formatter.format(selectedSailing.tariff.price)}</span>
                  <span className="tit">{selectedSailing.name}</span>
                </div>
              </div>
            </div>
          </div>


          {
            searchData.returnDate != null && (
              <>
                <div className="m-bxBillPay__bill">
                  <div className="o-cardTicket o-cardTicket--min">
                    <div className="a-tagTray"><span>Trayecto de vuelta</span></div>
                    <div className="bx">
                      <div className="o-cardTicket__fecha">
                        {searchData.return_date}
                      </div>
                                                                    
                      <div className="o-cardTicket__logo">
                        <div className="bx">
                          <img src={logo(selectedSailing.sailingData.company)}  />
                        </div>
                      </div>
                      <div className="o-cardTicket__trayecto">
                        <div className="bx">
                          <div className="row">
                            <div className="cardHead">
                              <div className="tit ht-small-bold text-center">Travesía</div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="orDe tit">
                              <div>{searchData.destiny}</div>
                              <div> 
                              <img src={flecha} alt="flecha-card" />
                              </div>
                              <div>{searchData.origen}</div>
                            </div>
                            <div className="duracion">
                              <div className="bx">
                                <img src={reloj} alt="" />
                                <span>{selectedSailingBack.sailingData.outward_time}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="o-cardTicket__resultado">
                        <span className="price">{formatter.format(selectedSailingBack.tariff.discounted_price) || formatter.format(selectedSailingBack.tariff.price)}</span>
                        <span className="tit">{selectedSailingBack.name}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </>)
          }

          <div className="m-iconPrice">
            <img src={timon} alt="" />
            <div className="txt">
              <span className="subtit">Total</span>
              <span className="tit">{formatter.format(total_price())}</span>
            </div>
            <div className="btnOrange-l btnArrow-l pay-button" id="buy-button"  onClick={() => handleClick()}  >Comprar </div>
          </div>
                                                  
          <div className="m-bxBillPay__price">
            <div className="tarjetas">
              <p className="ht-body-medium">Podras realizar tu pago con: </p>
              <img src={tarjetas} alt="" />
            </div>
            
          </div>

         
                                                    
        
        </div>
      </div>

    </div>
  </div>

  <Modal isOpen={isModalOpen} onClose={closeModal}>
    <h2>Conectando con la naviera</h2>
    <p>Estamos realizando su reserva.</p>
  </Modal>
  </>);
}